module.exports = {
  content: [
    './pages/**/*.{js,ts,jsx,tsx}',
    './src/common/**/*.{js,ts,jsx,tsx}',
    './src/product/**/*.{js,ts,jsx,tsx}',
    './src/category/**/*.{js,ts,jsx,tsx}',
    './src/bearing-hub/**/*.{js,ts,jsx,tsx}',
    './src/free-form-hub/**/*.{js,ts,jsx,tsx}',
    './src/company-order-tracking/**/*.{js,ts,jsx,tsx}',
    './src/layout/**/*.{js,ts,jsx,tsx}',
    './src/components/**/*.{js,ts,jsx,tsx}',
    './src/hooks/**/*.{js,jsx,ts,tsx}',
    './public/**/*.html',
  ],
  future: {
    removeDeprecatedGapUtilities: true,
    purgeLayersByDefault: true,
  },
  theme: {
    container: {
      center: true,
      padding: '1rem',
    },
    screens: {
      sm: '536px',
      md: '720px',
      lg: '940px',
      xl: '1200px',
    },
    minWidth: {
      button: '23.5rem',
      0: '0',
    },
    extend: {
      height: {
        'marketing-banner': '32px',
        'delivery-location-banner': '110px',
      },
      width: {
        quarter: '25%',
        third: '33.33333%',
        half: '50%',
      },
      maxHeight: {
        modal: '80vh',
      },
      boxShadow: {
        'lg-dark': '0 5px 15px -10px rgba(0, 0, 0, 1.0)',
      },
      flex: {
        quarter: '0 1 25%',
        half: '0 1 50%',
        'shrink-half': '0 1 50%',
        'grow-half': '1 0 50%',
        full: '1 0 100%',
      },
      fontSize: {
        xxs: '1.1rem',
        xs: '1.2rem',
        sm: '1.4rem',
        md: '1.5rem',
        base: '1.6rem',
        xm: '1.8rem',
        lg: '2rem',
        xl: '1.4rem',
        '2xl': '1.6rem',
        '3xl': '2.2rem',
        '4xl': '2.6rem',
        '5xl': '3rem',
        '6xl': '6rem',
      },
      borderWidth: {
        DEFAULT: '1px',
        0: '0',
        2: '2px',
        4: '4px',
        8: '8px',
        15: '15px',
      },
      fontFamily: {
        sans: ['Roboto', 'Arial', 'sans-serif'],
      },
      lineHeight: {
        '6xl': '8rem',
        '5xl': '3.5rem',
        '4xl': '3.1rem',
        '3xl': '2.7rem',
        '2xl': '2.1rem',
        xl: '2rem',
      },
      colors: {
        igus: {
          primary: '#F07D00 !important',
          'primary-600': '#D26E00 !important',
          info: '#2C74A9 !important',
          green: '#209C49 !important',
        },
        availability: {
          fastlane: '#00cf45',
          fast: '#209c49',
          slow: '#f7ad00',
          'on-request': '#787878',
        },
        gray: {
          600: '#000000',
          500: '#363636',
          400: '#626262',
          300: '#787878',
          250: '#DEDEDE',
          225: '#b9b9b9',
          200: '#D8D8D8',
          100: '#ECECEC',
          80: '#E9E9E9',
          50: '#F2F2F2',
          0: '#FFFFFF',
        },
        red: {
          0: '#CC0000',
        },
      },
      transitionProperty: {
        'max-height': 'max-height',
      },
    },
  },
  plugins: [],
};
